import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'
import ProgressBar from 'react-bootstrap/ProgressBar'
import {useEffect, useState} from 'react'
import { number } from 'yup/lib/locale'
import { useAuth } from '../../../../app/modules/auth'

const itemClass = 'ms-1 ms-lg-3'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'

const Navbar = () => {
  const {config} = useLayout()
 const [checkStatus, setCheckStatus] =  useState<number | 0>(0)
  const [userTypee, setUserTypee] = useState(false)
  let statuscheck =Number(localStorage.getItem('account_verified'))
  const {currentUser} = useAuth()
//  setCheckStatus(statuscheck)

  function verification() {
  
   // const parsedItem = JSON.parse(getStatus)
    // console.log("dfngjhdj",getStatus)
    //  setCheckStatus(localStorage.getItem('account_verified'))
     //setCheckStatus(parsedItem.account_verified)
     
    //  setCheckStatus(JSON.parse(getStatus));
    
  }

  function toCheckUserType() {
    let userType = localStorage.getItem('user_type')
    if (userType === 'Super Admin') {
      setUserTypee(true)
    }
  }
  useEffect(() => {

    // verification()
    toCheckUserType()
  }, [])
  return (
    <>
      <span style={{marginLeft: '5%', marginTop: '2%', width: '50%'}}>
        {/* Update profile 40% */}
        {statuscheck == 3 ? (
          ''
        ) : (
          <>
            {userTypee ? (
              ''
            ) : (
              <>
                {/* <ProgressBar variant='success' now={60} label={`${60}%`} />
                <Link to='/update-profile' style={{marginLeft: '250px'}}>
                  Update Profile{' '}
                </Link> */}
                 {/* <div className='d-flex align-items-center w-200px w-sm-300px flex-column  '>
                <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                  <span className='fw-bold fs-6 text-gray-400'> <Link to='/update-profile'>
                  Update Profile
                </Link></span>
                  <span className='fw-bolder fs-6'>60%</span>
                </div>
                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                  <div
                    className='bg-success rounded h-5px'
                    role='progressbar'
                    style={{width: '60%'}}
                  ></div>
                </div>
              </div> */}
              </>
            )}
          </>
        )}

      </span>
      <div className='app-navbar flex-shrink-0'>
        {/* 
      <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTSVG path='/assets/gen032.svg' className={btnIconClass} />
        </div>
      </div> */}

        {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTSVG path='/assets/gen022.svg' className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div> */}

        {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTSVG path='/assets/com012.svg' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
  <div className='mt-4 mr-80' style={{ fontWeight: 'bold', fontSize: '1.2em', textTransform: 'uppercase' }}>{currentUser?.accouont_holder_name}</div>
  <div  style={{ fontSize: '1.0em', textTransform: 'lowercase' }}>{currentUser?.email_id}</div>
</div>



        <div className={clsx('app-navbar-item', itemClass)}>
          <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
          >
            <img src='https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png' alt='' />
          </div>
          <HeaderUserMenu />
        </div>

        {/* {config.app?.header?.default?.menu?.display && (
          <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
            <div
              className='btn btn-icon btn-active-color-primary w-35px h-35px'
              id='kt_app_header_menu_toggle'
            >
              <KTSVG path='/assets/txt001.svg' className={btnIconClass} />
            </div>
          </div>
        )} */}
      </div>
    </>
  )
}

export {Navbar}
